import { action, autorun, makeAutoObservable, reaction } from 'mobx';
import { ControllerAppModel } from './ControllerAppModel';
import { GameInfo } from '@/types';

export class ControllerUIModel {
  showEnterNameDialog = false;
  showSettingsDialog = false;
  showGameInfoDialog = false;
  showPlayersDialog = false;
  showMenuDialog = false;
  isFullscreen = false;

  constructor(private appModel: ControllerAppModel) {
    makeAutoObservable(this, {}, { autoBind: true });
    this.setupListeners();
    this.setupReactions();
  }

  toggleFullscreen() {
    this.isFullscreen = !this.isFullscreen;
  }

  toggleShowGameInfo(show?: boolean) {
    this.showGameInfoDialog = show ?? !this.showGameInfoDialog;
  }

  setupListeners() {
    this.initializeFullscreenListeners();
  }

  setupReactions() {
    this.setupShowEnterNameDialogReaction();
    this.fullscreenReaction();
  }

  setupShowEnterNameDialogReaction() {
    autorun(() => {
      if (!this.appModel.user) {
        this.showEnterNameDialog = true;
        return;
      }

      const screenName = this.appModel.user.screenName;
      if (!screenName) {
        this.showEnterNameDialog = true;
      }
    });
  }

  initializeFullscreenListeners() {
    document.addEventListener(
      'fullscreenchange',
      action((e) => {
        this.isFullscreen = document.fullscreenElement !== null;
      }),
    );
  }

  fullscreenReaction() {
    return reaction(
      () => this.isFullscreen,
      (isFullscreen) => {
        if (isFullscreen) {
          document.documentElement.requestFullscreen();
        } else {
          try {
            document.exitFullscreen();
          } catch (e) {
            console.warn('Error exiting fullscreen', e);
          }
        }
      },
    );
  }
}
